import { Tooltip } from '@nextui-org/react';
import React from 'react';
import styled from 'styled-components';

const StyledTextTooltip = styled(Tooltip).attrs(({ css, theme }) => ({
  css: {
    ...(css ?? {}),
    div: {
      width: 'max-content',
    },
    background: theme.colors.neutrals.black,
    padding: '0.5rem',
    borderRadius: '2px',
    fontSize: theme.fontVariants.desktop.caption.md.fontSize,
    lineHeight: theme.fontVariants.desktop.caption.md.lineHeight,
    color: theme.colors.neutrals.white,

    span: {
      background: theme.colors.neutrals.black,
    },
  },
}))`
  min-width: 0%;
`;

export type Placement =
  | 'top'
  | 'topStart'
  | 'topEnd'
  | 'left'
  | 'leftStart'
  | 'leftEnd'
  | 'bottom'
  | 'bottomStart'
  | 'bottomEnd'
  | 'right'
  | 'rightStart'
  | 'rightEnd';

interface TextTooltipProps {
  children: React.ReactElement;
  tooltipText: string;
  isDisabled?: boolean;
  placement?: Placement;
}

const TextTooltip = ({ children, tooltipText, placement }: TextTooltipProps) => {
  return (
    <StyledTextTooltip content={tooltipText} placement={placement || 'top'}>
      {children}
    </StyledTextTooltip>
  );
};

export default TextTooltip;
